var exports = {
  "kL": "x2b2fbebb--f627c8--container",
  "d4": "x2b2fbebb--f627c8--star",
  "vu": "x2b2fbebb--f627c8--active",
  "PT": "x2b2fbebb--f627c8--hover",
};

module.exports = exports;
